/* eslint-disable react-hooks/rules-of-hooks */
import React from "react";
import { Modal } from "react-bootstrap";

interface Props {
  show?: any;
  onHide?: any;
  children?: any;
  className?: any;
  backdropClassName?: any;
}

const HEPopup: React.FC<Props> = ({
  show,
  onHide,
  children,
  className,
  backdropClassName,
}) => {
  return (
    <>
      <Modal
        className={className}
        show={show}
        onHide={onHide}
        backdrop="static"
        backdropClassName={backdropClassName}
      >
        {children}
      </Modal>
    </>
  );
};

export default HEPopup;
